import ClientesRecomendadosView from './ClientesRecomendadosView.vue'
import CreacionClientesRecomendados from './CreacionClientesRecomendados.vue'
import EdicionClientesRecomendadosView from './EdicionClientesRecomendadosView.vue'

export default [
  {
    path: '',
    component: ClientesRecomendadosView
  },
  {
    path: 'nuevo',
    component: CreacionClientesRecomendados
  },
  {
    path: 'edicion/:id',
    component: EdicionClientesRecomendadosView
  }
];